<template>
    <div class="comp-no-data ui-nodata">
        <div class="nodata-icon-box">
            <i class="icon iconshare icon-nodata"></i>
        </div>
        <div class="nodata-text">{{messages[language].noData}}</div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                messages: {
                    en: {
                        noData: 'No Data'
                    },
                    zh: {
                        noData: '暂无数据'
                    }
                }
            }
        },
        methods: {

        }
    }
</script>
<style lang="less">
    .ui-nodata {
        padding: 4rem 0;
        text-align: center;
        .iconshare {
            font-size: 40px;
            color: #DBDBDB;
        }
        .nodata-text {
            margin-top: 4px;
            font-size: 12px;
            color: #DBDBDB;
        }
    }
</style>
